import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('sourceBadge');

    return {
        JOHN_DEERE: t('johnDeere')
    };
};

export default useTranslation;
